import {Chip, Stack, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';

const HarvestCardValue = ({
  value,
  unit,
  extra,
  fullHarvest,
  dataTestId,
}: {
  value: number | string | null;
  unit: string;
  extra?: string;
  fullHarvest?: boolean | null | undefined;
  dataTestId?: string;
}) => {
  const theme = useTheme();
  const {t} = useTranslation('common');

  return (
    <Stack direction="row" spacing={0.5} alignItems="flex-end" data-testid={dataTestId}>
      <Typography variant="subtitle2" lineHeight={1} fontSize="1rem">
        {value}
      </Typography>
      <Typography
        variant="subtitle2"
        fontSize="0.7rem"
        lineHeight={1}
        sx={{textTransform: 'uppercase'}}
        color={theme.palette.text.disabled}
      >
        {unit}
      </Typography>
      {extra && (
        <Typography variant="subtitle2" fontSize="0.7rem" lineHeight={1} color={theme.palette.text.disabled}>
          {extra}
        </Typography>
      )}
      {fullHarvest && (
        <Chip
          size="small"
          label={t('fullCage')}
          sx={{
            textTransform: 'uppercase',
            fontSize: '0.55rem',
            height: 12,
            color: theme.palette.background.default,
            cursor: 'default',
            background: theme.palette.text.disabled,
            fontWeight: 900,
            marginBottom: 0.5,
            paddingLeft: 0.6,
            paddingRight: 0.6,
            letterSpacing: 0.6,
            '& .MuiChip-label': {
              paddingLeft: 0,
              paddingRight: 0,
            },
          }}
        />
      )}
    </Stack>
  );
};

export default HarvestCardValue;
